module.exports = __webpack_public_path__ + "b2a8ab089d8c59bbe84899c8bf57da91.svg";